var map = {
	"./a20plus.json": [
		54127,
		9292
	],
	"./a3.json": [
		38770,
		2101
	],
	"./bhopball4.json": [
		46982,
		4910
	],
	"./bite7.json": [
		79313,
		7719
	],
	"./bite9.json": [
		50099,
		8696
	],
	"./bite9wnb.json": [
		27948,
		3089
	],
	"./dashdance25.json": [
		10936,
		5898
	],
	"./ddr_grand_prix.json": [
		44597,
		4899
	],
	"./ddr_sn.json": [
		15804,
		9684
	],
	"./ddr_world.json": [
		95123,
		2493
	],
	"./ddr_x.json": [
		42015,
		1727
	],
	"./ddr_x3.json": [
		21100,
		8918
	],
	"./donkeykonga.json": [
		30394,
		8333
	],
	"./drs.json": [
		66341,
		5524
	],
	"./extreme.json": [
		45086,
		2715
	],
	"./ez2ac_fnex.json": [
		20127,
		9906
	],
	"./first_step_26.json": [
		88280,
		5513
	],
	"./iidx.json": [
		64252,
		2704
	],
	"./itl24.json": [
		48255,
		3559
	],
	"./itl25.json": [
		18060,
		750
	],
	"./jubeat-beyondave.json": [
		94437,
		9386
	],
	"./maimai.json": [
		84252,
		9971
	],
	"./motl6.json": [
		50512,
		3768
	],
	"./ongeki.json": [
		45211,
		6577
	],
	"./pump-phoenix.json": [
		10690,
		8398
	],
	"./pump-phoenix_2.json": [
		81331,
		2791
	],
	"./pump.json": [
		90292,
		2780
	],
	"./rip15singles.json": [
		27220,
		5589
	],
	"./sdvx_eg.json": [
		74908,
		7554
	],
	"./sdvx_nabla.json": [
		14818,
		363
	],
	"./septa2-iidx.json": [
		65494,
		3237
	],
	"./shine2025.json": [
		84650,
		428
	],
	"./smx.json": [
		37546,
		1444
	],
	"./storm2025_bracket.json": [
		96871,
		7630
	],
	"./storm2025_pools.json": [
		64132,
		4225
	],
	"./storm2026.json": [
		23577,
		1416
	],
	"./storm24.json": [
		81785,
		7619
	],
	"./syr5.json": [
		39315,
		7034
	],
	"./tbd5.json": [
		19227,
		5213
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79184;
module.exports = webpackAsyncContext;